module.exports = require("react-youtube");